import { LOCALES } from "common/constants";
import { blobURL } from "common/StringUtils";
import React from "react";
import Slider from "react-slick";

const logos = `${blobURL}/SAMARBETSPARTNERS.png`;
const logos_eng = `${blobURL}/partners_eng.png`;
const microsoft = `${blobURL}/FNU_home_page__4_-removebg-preview.png`;
const trygg = `${blobURL}/trygg.png`;
const Fortnox = `${blobURL}/fortnox.png`;
const bank = `${blobURL}/bankId.png`;
const spp = `${blobURL}/spp.png`;
const euroAccident = `/assets/euro-accident.png`;

let language = localStorage.getItem("i18nextLng");

const slideComp = () => {
  const settings = {
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 7,
    arrow: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
          dots: false,
          infinite: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 2,
          infinite: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          autoplay: true,
          dots: false,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          dots: false,
        },
      },
    ],
  };

  const partnersData = [
    {
      image: language === LOCALES.EN_US ? logos_eng : logos,
    },
    {
      image: microsoft,
    },
    {
      image: trygg,
    },
    {
      image: Fortnox,
    },
    {
      image: bank,
    },
    {
      image: spp,
    },
    {
      image: euroAccident,
    },
  ];

  return (
    <Slider {...settings}>
      {partnersData?.map((data, idx) => {
        return (
          <ul key={idx} className="footer_image mb-0">
            <li className="pb-0">
              <img
                src={data?.image}
                className="img-fluid"
                alt="slide-img"
                loading="lazy"
              />
            </li>
          </ul>
        );
      })}
    </Slider>
  );
};

export default slideComp;
